import React from "react";
import Select from "react-select";
import { resolveSelectValue } from "../../utils/resolveSelectValue";

const CustomSelect = (props) => {
  const { options, onChange, label, labelClass, value, isMulti, ...customProps } =
    props;
  const isControlled = value !== undefined;
  const resolvedValue = React.useMemo(
    () =>
      isControlled
        ? resolveSelectValue(value, options, Boolean(isMulti))
        : undefined,
    [isControlled, value, options, isMulti]
  );

  return (
    <div className="my-[10px]">
      <p className={`text-[#1E1E1E] font-medium mb-1  ${labelClass}`}>
        {label}
      </p>
      <Select
        options={options}
        onChange={onChange}
        isMulti={isMulti}
        {...customProps}
        {...(isControlled ? { value: resolvedValue } : {})}
      />
    </div>
  );
};

export default CustomSelect;
